window.collapsibleContent = (() => {
  if (window.collapsibleContent) return true;

  const ANIMATION_DURATION = 300;
  const FADE_DURATION = 200;
  const FADE_DELAY = 50;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  // Track ongoing animations to prevent conflicts
  const animatingItems = new WeakSet();

  const closeAccordion = (details) => {
    if (animatingItems.has(details) || !details.hasAttribute('open')) return;

    animatingItems.add(details);
    const content = details.querySelector('.accordion__content');
    const summary = details.querySelector('summary');
    const caret = summary.querySelector('.icon-caret');

    const startHeight = details.offsetHeight;
    const endHeight = summary.offsetHeight;

    details.style.overflow = 'hidden';

    const heightAnimation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: ANIMATION_DURATION, easing: EASING }
    );

    if (content) {
      // Use fill: 'forwards' to hold opacity at 0 until element is hidden
      content.animate(
        { opacity: [1, 0] },
        { duration: FADE_DURATION, easing: EASING, fill: 'forwards' }
      );
    }

    // Animate caret rotation back to 0
    if (caret) {
      caret.getAnimations().forEach(a => a.cancel());
      caret.animate(
        { transform: ['rotate(180deg)', 'rotate(0deg)'] },
        { duration: ANIMATION_DURATION, easing: EASING, fill: 'forwards' }
      );
    }

    heightAnimation.onfinish = () => {
      details.removeAttribute('open');
      details.style.height = '';
      details.style.overflow = '';
      animatingItems.delete(details);
    };
  };

  const openAccordion = (details) => {
    if (animatingItems.has(details) || details.hasAttribute('open')) return;

    animatingItems.add(details);
    const content = details.querySelector('.accordion__content');
    const summary = details.querySelector('summary');
    const caret = summary.querySelector('.icon-caret');

    // Measure collapsed height
    const startHeight = details.offsetHeight;

    // Set open to measure expanded height
    details.setAttribute('open', '');
    details.style.overflow = 'hidden';
    const endHeight = details.scrollHeight;

    // Set initial state for animation
    details.style.height = `${startHeight}px`;

    // Force reflow before starting animation
    details.offsetHeight;

    const heightAnimation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: ANIMATION_DURATION, easing: EASING }
    );

    if (content) {
      content.animate(
        { opacity: [0, 1] },
        { duration: FADE_DURATION, easing: EASING, delay: FADE_DELAY, fill: 'both' }
      );
    }

    if (caret) {
      caret.getAnimations().forEach(a => a.cancel());
      caret.animate(
        { transform: ['rotate(0deg)', 'rotate(180deg)'] },
        { duration: ANIMATION_DURATION, easing: EASING, fill: 'forwards' }
      );
    }

    heightAnimation.onfinish = () => {
      details.style.height = '';
      details.style.overflow = '';
      animatingItems.delete(details);
    };
  };

  const closeAllExceptCurrent = (currentItem, items) => {
    items.forEach((item) => {
      if (item !== currentItem && item.hasAttribute('open')) {
        closeAccordion(item);
      }
    });
  };

  const toggleDetails = (item, items) => {
    const isOpen = item.hasAttribute('open');

    if (isOpen) {
      closeAccordion(item);
    } else {
      openAccordion(item);
      closeAllExceptCurrent(item, items);
    }
  };

  const addClickListener = (item, items) => {
    item.querySelector('summary').addEventListener('click', (e) => {
      e.preventDefault();
      toggleDetails(item, items);
    });
  };

  const initializeFaqItems = () => {
    const faqItems = document.querySelectorAll('.js-collapsible');
    faqItems.forEach((item) => addClickListener(item, faqItems));
  };

  initializeFaqItems();

  return true;
})();
